"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attendeeBackgroundFilterChangeLatency = attendeeBackgroundFilterChangeLatency;
exports.attendeeUploadedUserBackground = attendeeUploadedUserBackground;
exports.attendeeUsedBackgroundFilter = attendeeUsedBackgroundFilter;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Rudder = _interopRequireWildcard(require("../rudder-web"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This client was automatically generated. ** Do Not Edit **
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
var setRudderTyperOptions = Rudder.setRudderTyperOptions;
var withRudderTyperContext = Rudder.withRudderTyperContext;
// Track Calls
function attendeeBackgroundFilterChangeLatency(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio attendee background filter change latency', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'attendee background filter change latency'
    }), withRudderTyperContext(options), callback);
  }
}
function attendeeUploadedUserBackground(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio attendee uploaded user background', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'attendee uploaded user background'
    }), withRudderTyperContext(options), callback);
  }
}
function attendeeUsedBackgroundFilter(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio attendee used background filter', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'attendee used background filter'
    }), withRudderTyperContext(options), callback);
  }
}
var clientAPI = {
  /**
   * Updates the run-time configuration of this RudderTyper client.
   *
   * @param {RudderTyperOptions} options - the options to upsert
   *
   * @typedef {Object} RudderTyperOptions
   * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setRudderTyperOptions: setRudderTyperOptions,
  /**
   * this action measures the time taken in changing the background filter feature for attendees
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio attendee background filter change latency
   * downstreamName: attendee background filter change latency
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  yes
   * trigger       : the measurement starts when the attendee triggers the background filter feature and ends when it is successfully added
   * destinations  : datadog,Mixpanel
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {AttendeeBackgroundFilterChangeLatency} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  attendeeBackgroundFilterChangeLatency: attendeeBackgroundFilterChangeLatency,
  /**
   * this action measures the time taken in uploading a custom user background for attendees
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio attendee uploaded user background
   * downstreamName: attendee uploaded user background
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  yes
   * trigger       : the measurement starts when the attendee uploads a custom user background and ends when it is successfully uploaded
   * destinations  : datadog,Mixpanel
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {AttendeeUploadedUserBackground} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  attendeeUploadedUserBackground: attendeeUploadedUserBackground,
  /**
   * this action tracks the users who use a background filter in Studio in order to understand how many users are using filters
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio attendee used background filter
   * downstreamName: attendee used background filter
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when user uses a background filter in studio
   * destinations  : datadog,Mixpanel
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {AttendeeUsedBackgroundFilter} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  attendeeUsedBackgroundFilter: attendeeUsedBackgroundFilter
};
var backgroundFilterAnalyticsClient = new Proxy(clientAPI, {
  get: function get(target, method) {
    if (typeof method === 'string' && target.hasOwnProperty(method)) {
      return target[method];
    }
    return function () {
      console.warn("\u26A0\uFE0F  You made an analytics call (".concat(String(method), ") that can't be found. Either:\n    a) Re-generate your ruddertyper client: `npx rudder-typer`\n    b) Add it to your Tracking Plan: https://app.rudderstack.com/trackingPlans/tp_2VcMepdGsODn30mzqfuBdd60Wrw"));
      var a = Rudder.getAnalyticsInstance();
      if (a) {
        a.track('Unknown Analytics Call Fired', {
          method: method
        }, withRudderTyperContext());
      }
    };
  }
});
var _default = exports["default"] = backgroundFilterAnalyticsClient;